var map = {
	"./campeonato_01.jpg": 33,
	"./campeonato_02.jpg": 34,
	"./campeonato_03.jpg": 35,
	"./campeonato_04.jpg": 36,
	"./campeonato_05.jpg": 37,
	"./campeonato_06.jpg": 38
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 299;